<template>
    <div class="v-icon mx-2 ">
        <v-btn
            @click="editItem(person)"
            class="info"
        >
            Edit
        </v-btn>
        <v-dialog
            :value="editPersonSummaryDialog"
            max-width="700px"
            persistent
        >
            <v-card v-if="editPersonSummaryDialog">
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Edit Person Summary</span>
                    <v-spacer />
                    <v-btn
                        @click.stop="closeEditItem()"
                        fab
                        rounded
                        small
                        text
                    >
                        X
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form
                        data-vv-scope="editPersonSummaryForm"
                        ref="editPersonSummaryForm"
                    >
                        <v-container
                            grid-list-md
                            pt-0
                        >
                            <v-layout wrap>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-text-field
                                        :error-messages="editNameErrors"
                                        @blur="$v.editName.$touch()"
                                        @input="$v.editName.$touch()"
                                        label="Name"
                                        v-model="editName"
                                    />
                                </v-flex>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-menu
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        min-width="290px"
                                        offset-y
                                        ref="dateOfBirthMenu"
                                        transition="scale-transition"

                                        v-model="dateOfBirthMenu"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                :error-messages="editDateOfBirthErrors"
                                                @blur="$v.editDateOfBirth.$touch()"
                                                @input="$v.editDateOfBirth.$touch()"
                                                label="Date of birth"
                                                readonly

                                                slot="activator"
                                                v-model="editDateOfBirth"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker
                                            :error-messages="editDateOfBirthErrors"
                                            :max="sixteenYearsAgo"
                                            @blur="$v.editDateOfBirth.$touch()"
                                            @input="dateOfBirthMenu = false && $v.editDateOfBirth.$touch()"
                                            min="1940-01-01"
                                            no-title
                                            ref="picker"
                                            scrollable
                                            v-model="editDateOfBirth"
                                        />
                                    </v-menu>
                                </v-flex>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-select
                                        :items="countryList(isLive = true)"
                                        height="46"
                                        item-text="name"
                                        item-value="countryId"
                                        label="Home Country"
                                        v-model="editHomeCountryId"
                                    />
                                </v-flex>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-text-field
                                        :error-messages="editEmailAddressWorkErrors"
                                        @blur="$v.editEmailAddressWork.$touch()"
                                        @input="$v.editEmailAddressWork.$touch()"
                                        label="Work Email"
                                        type="text"
                                        v-model="editEmailAddressWork"
                                    />
                                </v-flex>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-select
                                        :items="livePersonnel()"
                                        height="46"
                                        item-text="name"
                                        item-value="personId"
                                        label="Manager"
                                        v-model="editManagerId"
                                    />
                                </v-flex>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-text-field
                                        label="REVUE Api Key"
                                        type="text"
                                        v-model="editGarProApiKey"
                                    />
                                </v-flex>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-text-field
                                        label="Azure AD ObjectId"
                                        type="text"
                                        v-model="editAzureAdObjectId"
                                    />
                                </v-flex>
                                <v-flex
                                    md12
                                    sm12
                                    xs12
                                >
                                    <v-select
                                        :items="[{Id: true, name: 'Live'}, {Id: false, name: 'Not Live'}]"
                                        item-text="name"
                                        item-value="Id"
                                        label="Is Live on System"
                                        v-model="editIsLive"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveEditItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeEditItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';

    import { SAVE_PERSON_MAIN_DETAILS_FIELD } from "@/store/person/actions";
import { LOAD_PERSON_SUMMARY_TO_EDIT, RESET_DEFAULT_PERSON_SUMMARY_TO_EDIT, SET_EDIT_PERSON_FORM_SECTION_STATE, TOGGLE_EDIT_PERSON_SUMMARY_DIALOG, UPDATE_PERSON_MAIN_DETAILS_FIELD } from "@/store/person/mutations";
import { FETCH_PERSON } from "../../../../store/person/actions";

    import { email, required } from 'vuelidate/lib/validators';

    export default {
        name: "EditPersonSummaryDialog",

        validations: {
            editName: {required},
            editDateOfBirth: {required},
            editEmailAddressWork: {email}
        },


        components: {},

        mixins: [
            EditTableFunctions,
        ],


        props: {
            person: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                // Required for editTableFunctions
                idName: 'personId',

                dateOfBirthMenu: false,
            }
        },

        computed: {
            editName: {
                get() {
                    return this.$store.state.person.editPerson.name;
                },
                set(value) {
                    this.updatePersonSummary('name', value);
                }
            },
            editNameErrors() {
                const errors = [];
                if (!this.$v.editName.$dirty) return errors;
                !this.$v.editName.required && errors.push('required.');
                return errors
            },
            editDateOfBirth: {
                get() {
                    return this.$store.state.person.editPerson.dateOfBirth.substring(0, 10);
                },
                set(value) {
                    this.updatePersonSummary('dateOfBirth', value);
                }
            },
            editDateOfBirthErrors() {
                const errors = [];
                if (!this.$v.editDateOfBirth.$dirty) return errors;
                !this.$v.editDateOfBirth.required && errors.push('required.');
                return errors
            },
            editHomeCountryId: {
                get() {
                    return this.$store.state.person.editPerson.homeCountryId;
                },
                set(value) {
                    this.updatePersonSummary('homeCountryId', value);
                }
            },
            editEmailAddressWork: {
                get() {
                    return this.$store.state.person.editPerson.emailAddressWork;
                },
                set(value) {
                    // If we are deleting a valid email address do this so it will pass server side email validation.
                    if (value == "") {
                        value = undefined;
                    }
                    this.updatePersonSummary('emailAddressWork', value);
                }
            },
            editEmailAddressWorkErrors() {
                const errors = [];
                if (!this.$v.editEmailAddressWork.$dirty) return errors;
                !this.$v.editEmailAddressWork.email && errors.push('Must be valid email address.');
                return errors
            },
            editManagerId: {
                get() {
                    return this.$store.state.person.editPerson.managerId;
                },
                set(value) {
                    this.updatePersonSummary('managerId', value);
                }
            },
            editGarProApiKey: {
                get() {
                    return this.$store.state.person.editPerson.revueApiKey;
                },
                set(value) {
                    this.updatePersonSummary('revueApiKey', value);
                }
            },
            editAzureAdObjectId: {
                get() {
                    return this.$store.state.person.editPerson.azureAdObjectId;
                },
                set(value) {
                    this.updatePersonSummary('azureAdObjectId', value);
                }
            },
            editIsLive: {
                get() {
                    return this.$store.state.person.editPerson.isLive;
                },
                set(value) {
                    this.updatePersonSummary('isLive', value);
                }
            },
            ...mapGetters(
            [
                "editPersonSummaryDialog",
                "editFeedback",
                "statusList",
                "countryList",
                "applicationTypeNameById",
                "feedbackTypeNameById",
                "statusNameById",
                "editPersonFormState",
                "livePersonnel",

            ]
            ),

            ...mapGetters({
                id: "editPersonId"
            })
        },


        watch: {
            dateOfBirthMenu(val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
        },

        mounted() {
            this.sixteenYearsAgo = moment().subtract(16, 'years').format('YYYY-MM-DD');
        },


        methods: {

            validate() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }


                this.$store.commit(SET_EDIT_PERSON_FORM_SECTION_STATE, {section: 'summary', state: formState});
            },

            async validateAll() {

                const results = Promise.all([
                    this.validate(),
                ]);

                await results;

                let resultsArray = [];

                resultsArray.push(this.editPersonFormState('summary'));

                const areValid = resultsArray.every((result) => {
                    return result == 'complete';
                });

                return areValid;
            },

            updatePersonSummary(field, value) {
                let data = {};
                data.field = field;
                data.value = value;
                this.$store.commit(UPDATE_PERSON_MAIN_DETAILS_FIELD, data);
            },
            toggleEditPersonSummaryDialog() {
                this.$store.commit(TOGGLE_EDIT_PERSON_SUMMARY_DIALOG);
            },
            ...mapActions({
                fetchItem: FETCH_PERSON,
                updateTableItemRecord: SAVE_PERSON_MAIN_DETAILS_FIELD,
            }),
            //
            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_SUMMARY_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_SUMMARY_TO_EDIT,
                // updateTableItemToEdit: ,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_SUMMARY_TO_EDIT,
            }),

        },

    }
</script>

<style scoped>
</style>
